// @flow
import React, { useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import scriptLoader from '../../helpers/scriptLoader';
import { selectLanguage } from '../../stores/partner';

const trustPilotScript =
  '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';

type Props = {
  templateId?: string,
  height?: string,
  width?: string,
  theme?: 'light' | 'dark'
};

const TrustpilotWidget = ({
  templateId = '53aa8807dec7e10d38f59f32',
  height = '95px',
  width = '162px',
  theme = 'light'
}: Props) => {
  const widgetRef = useRef(null);
  const locale = useSelector(selectLanguage);

  useEffect(() => {
    scriptLoader(trustPilotScript)
      .then(() => {
        if (widgetRef.current !== null) {
          window.Trustpilot.loadFromElement(widgetRef.current, true);
        }
      })
      .catch((err) => {
        // Ensure rejection is caught
        // eslint-disable-next-line no-console
        console.error(err);
      });
  }, [templateId, height, width, theme]);

  return (
    <div
      ref={widgetRef}
      className="trustpilot-widget"
      data-locale={locale}
      data-template-id={templateId}
      data-businessunit-id="53f5ba83000064000579d742"
      data-style-height={height}
      data-style-width={width}
      data-theme={theme}
      data-stars="1,2,3,4,5"
    />
  );
};

export default TrustpilotWidget;
